<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <div class="table-toolbar mb-4">
      <div class="row">
        <div class="col-md-12">
          <p-toolbar styleClass="bg-white">
            <div class="p-toolbar-group-start">
              <div class="d-flex flex-column justify-content-start align-items-start">
                <div class="d-flex align-items-center fs-5 fw-bold">
                  {{ 'connectSquareupPosAccount.manageConnectionsHere' | transloco }}
                </div>
              </div>
            </div>
          </p-toolbar>
        </div>
      </div>
    </div>
    <!-- Overlay Panel for Disconnect Action -->
    <p-overlayPanel #posMenuPanel>
      <div class="px-2 py-2 small text-start">
        <div class="mb-2 text-muted fw-semibold">{{ 'connectSquareupPosAccount.managePosConnection' | transloco }}</div>

        <button
          pButton
          type="button"
          class="p-button p-button-danger p-button-sm justify-content-center  text-center w-100"
          (click)="confirmDisconnectPosAccount(); posMenuPanel.hide()">
          {{ 'connectSquareupPosAccount.disconnectAccount' | transloco }}
        </button>

        <div class="text-muted mt-3 small">
          {{ 'connectSquareupPosAccount.disconnectingWill' | transloco }}
          <ul class="mt-1 ps-3">
            <li>{{ 'connectSquareupPosAccount.stopSyncing' | transloco }}</li>
            <li>{{ 'connectSquareupPosAccount.removeAnalytics' | transloco }}</li>
            <li>{{ 'connectSquareupPosAccount.disableRealtime' | transloco }}</li>
            <li>{{ 'connectSquareupPosAccount.reconnectAnytime' | transloco }}</li>
          </ul>
          {{ 'connectSquareupPosAccount.proceedIfSure' | transloco }}
        </div>
      </div>
    </p-overlayPanel>

    <!-- POS Accounts -->
    <div class="mt-4">
      <div class="row">
        @for (posAccount of posAccounts; track posAccount) {
          <div class="col-12 col-md-6 mb-3">
            <div class="card shadow-sm border-0 rounded-4 overflow-hidden h-100 bg-light-subtle position-relative">
              <div class="card-body p-4">
                <!-- Logo & Name -->
                <div class="d-flex align-items-center mb-3">
                  <img
                    [src]="posAccount.full_format_logo_url || 'assets/images/No-Image.png'"
                    class="rounded-circle me-3 border"
                    style="width: 44px; height: 44px; object-fit: cover;" />
                    <div class="fs-5 text-dark-emphasis text-capitalize">{{ posAccount.name }}</div>
                  </div>
                  <!-- Details -->
                  <div class="d-grid gap-2 small text-body-secondary">
                    <div>{{ 'connectSquareupPosAccount.country' | transloco: { value: posAccount?.country } }}</div>
                    <div>{{ 'connectSquareupPosAccount.currency' | transloco: { value: posAccount?.currency } }}</div>
                    <div>{{ 'connectSquareupPosAccount.type' | transloco: { value: posAccount?.type } }}</div>
                    <div>{{ 'connectSquareupPosAccount.storeConnectedAt' | transloco: { value: (posAccount?.created_at | date: 'dd/MM/yyyy hh:mm a') } }}</div>
                    @if (SquarePOSLoggedInAt) {
                      <div>{{ 'connectSquareupPosAccount.connectedAt' | transloco: { value: (SquarePOSLoggedInAt | date: 'dd/MM/yyyy hh:mm a') } }}</div>
                    }
                    @if (SquarePOSTokkenExpireAt) {
                      <div>{{ 'connectSquareupPosAccount.expiresAt' | transloco: { value: (SquarePOSTokkenExpireAt | date: 'dd/MM/yyyy hh:mm a') } }}</div>
                    }
                  </div>
                </div>
                <!-- 3-dot Menu Button -->
                <div class="position-absolute end-0 top-0 p-2">
                  <button
                    class="btn btn-light btn-sm rounded-circle"
                    (click)="posMenuPanel.toggle($event)">
                    •••
                  </button>
                </div>
              </div>
            </div>
          }

          <!-- Empty State -->
          @if (!posAccounts.length) {
            <div class="col-12">
              <div class="text-center py-4">
                <button
                  pButton
                  type="button"
                  class="p-button p-button-outlined p-button-sm fw-semibold shadow-sm"
                  (click)="onConnectSquareupPosAccount()">
                  {{ 'connectSquareupPosAccount.connectPosAccount' | transloco }}
                </button>
                <div class="text-muted mt-2 small">
                  {{ 'connectSquareupPosAccount.noPosConnectedYet' | transloco }}
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      @if (posAccounts && posAccounts.length > 0) {
        <div>
          <app-sync-products [SyncProducts]="Products" [SquareupSyncProducts]="SquareupSyncProducts"></app-sync-products>
        </div>
      }
    </div>
  </div>

  <!-- Success Dialog -->
  <p-dialog [header]="'connectSquareupPosAccount.squareupPosConnection' | transloco" [(visible)]="isConnectSquareupSuccessDialogVisible" [modal]="true"
    (onHide)="closeSquareupCheckoutDialog()" [style]="{ 'width': '430px'}">
    <div class="d-flex flex-column align-items-center px-3 py-3 text-center">
      <img src="assets/images/tik-image.jpg" alt="Success" class="img-fluid rounded-circle" style="width: 100px;">
      <div class="h5 mt-4 text-secondary">
        {{ 'connectSquareupPosAccount.congratulationsConnected' | transloco }}
      </div>
      <div class="text-secondary">
        {{ 'connectSquareupPosAccount.incomingProductsSynced' | transloco }}
      </div>
    </div>
  </p-dialog>
